document.addEventListener('DOMContentLoaded', () => {
  const trackAbsoluteEvent = (name, params = {}) => {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  };

  document.querySelectorAll('a[href^="tel:"]').forEach((link) => {
    link.addEventListener('click', () => {
      trackAbsoluteEvent('phone_click', { link_text: link.textContent.trim(), page_path: window.location.pathname });
    });
  });

  document.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
    link.addEventListener('click', () => {
      trackAbsoluteEvent('email_click', { page_path: window.location.pathname });
    });
  });

  document.querySelectorAll('a[href*="/pages/request-a-quote"]').forEach((link) => {
    link.addEventListener('click', () => {
      trackAbsoluteEvent('quote_start', { source_page: window.location.pathname });
    });
  });

  if (document.querySelector('[data-quote-success]')) {
    trackAbsoluteEvent('quote_submit', { page_path: window.location.pathname });
  }
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const panel = document.querySelector('[data-mobile-menu]');

  if (toggle && panel) {
    const setOpen = (open) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) close?.focus();
      else toggle.focus();
    };

    toggle.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    panel.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) setOpen(false);
    });
  }

  const mobileStickyCta = document.querySelector('[data-mobile-cta-scroll]');
  const landingHero = document.querySelector('.home-hero');

  if (mobileStickyCta && landingHero) {
    const mobileBreakpoint = window.matchMedia('(max-width: 720px)');
    let heroObserver;

    const setMobileCtaVisible = (visible) => {
      mobileStickyCta.classList.toggle('is-visible', visible);
      mobileStickyCta.setAttribute('aria-hidden', String(!visible));
      mobileStickyCta.toggleAttribute('inert', !visible);
    };

    const watchLandingHero = () => {
      heroObserver?.disconnect();
      setMobileCtaVisible(false);
      if (!mobileBreakpoint.matches) return;

      heroObserver = new IntersectionObserver(([entry]) => {
        const hasPassedHero = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        setMobileCtaVisible(hasPassedHero);
      }, { threshold: 0 });

      heroObserver.observe(landingHero);
    };

    watchLandingHero();
    if (mobileBreakpoint.addEventListener) mobileBreakpoint.addEventListener('change', watchLandingHero);
    else mobileBreakpoint.addListener(watchLandingHero);
  }

  document.querySelectorAll('[data-multistep-form]').forEach((form) => {
    const steps = [...form.querySelectorAll('[data-form-step]')];
    const progressLabel = form.querySelector('[data-progress-label]');
    const progressTitle = form.querySelector('[data-progress-title]');
    const progressBar = form.querySelector('[data-progress-bar]');
    const error = form.querySelector('[data-form-error]');
    let currentStep = 0;

    if (!steps.length) return;
    let quoteStarted = false;
    form.addEventListener('focusin', () => {
      if (quoteStarted) return;
      quoteStarted = true;
      trackAbsoluteEvent('quote_form_start', { page_path: window.location.pathname });
    });

    const showStep = (index, moveFocus = true) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== currentStep; });
      if (progressLabel) progressLabel.textContent = `Step ${currentStep + 1} of ${steps.length}`;
      if (progressTitle) progressTitle.textContent = steps[currentStep].dataset.stepTitle || '';
      if (progressBar) progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
      if (error) error.hidden = true;
      if (moveFocus) steps[currentStep].querySelector('legend')?.focus();
    };

    const validateCurrentStep = () => {
      const controls = [...steps[currentStep].querySelectorAll('input, textarea, select')];
      const invalid = controls.find((control) => !control.checkValidity());
      if (!invalid) return true;
      if (error) error.hidden = false;
      invalid.reportValidity();
      return false;
    };

    form.querySelectorAll('[data-step-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (validateCurrentStep()) showStep(currentStep + 1);
      });
    });

    form.querySelectorAll('[data-step-back]').forEach((button) => {
      button.addEventListener('click', () => showStep(currentStep - 1));
    });

    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) {
        const group = form.querySelectorAll(`input[name="${CSS.escape(event.target.name)}"]`);
        group.forEach((input) => input.closest('label')?.classList.toggle('selected', input.checked));
      }
    });

    form.addEventListener('invalid', (event) => {
      const stepIndex = steps.findIndex((step) => step.contains(event.target));
      if (stepIndex >= 0 && stepIndex !== currentStep) showStep(stepIndex, false);
      if (error) error.hidden = false;
    }, true);

    showStep(0, false);
  });

  document.querySelectorAll('[data-project-archive]').forEach((archive) => {
    const button = archive.parentElement.querySelector('[data-project-archive-more]');
    if (!button) return;

    button.addEventListener('click', () => {
      const hiddenItems = [...archive.querySelectorAll('[data-project-archive-item][hidden]')];
      const revealCount = Number.parseInt(button.dataset.revealCount, 10) || 9;
      hiddenItems.slice(0, revealCount).forEach((item) => { item.hidden = false; });
      if (hiddenItems.length <= revealCount) button.closest('.project-archive-actions')?.remove();
    });
  });
});
